import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

// import * as AppPropTypes from '../../../lib/PropTypes';
import styles from '../../../../styles/icons/logos/logo.module.scss';

import logo from '../../../../img/voisin/logo_white.svg';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function VoisinWhite({ className }) {
    return (
        <img
            src={logo}
            className={classNames([styles.container, { [className]: className !== null }])}
            alt="Voisin"
        />
    );
}

VoisinWhite.propTypes = propTypes;
VoisinWhite.defaultProps = defaultProps;

export default VoisinWhite;
